import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../../constants/Common';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import capitalGoodsAPI from '../../../../../services/modules/IP/capitalGoodAPI';
import capitalGoodsJSON from '../../../../../services/modules/JSON/capitalGoods';
import supplierInfo from '../../../../../services/modules/OM/supplierInfoDetails';
import AverageForm from '../../../../Forms/AverageForm';
import {upstreamKey} from '../../../../Forms/Constants/IP/UpstreamKeyLabel';
import Loader from '../../../../Loader/Loader';
import {IComponentProps} from '../../../Common/perquisiteMaster';

const CapitalGoodSupplierBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };
  const [suppliers, setSuppliers] = useState([]);
  const [editData, setEditData] = useState<any>(undefined);
  const [allJSON, setAllJSON] = useState(false);

  useEffect(() => {
    if (allJSON) {
      Promise.all([
        record?.referenceRecordId &&
          capitalGoodsAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
        supplierInfo(
          APITypeEnum.GET_ALL,
          undefined,
          `${record?.facility}/${record?.year}/upstream`
        )
      ])
        .then(([res1, supplierInfo]) => {
          setSuppliers(
            supplierInfo.map((item: any) => {
              return {
                label: item?.[upstreamKey.SUPPLIER_NAME],
                value: item._id,
                capitalGoodsSupplied: item?.capitalGoodsSupplied,
                facility: item?.facility
              };
            })
          );

          if (res1?.data?.isDeleted === false) {
            caForm.setFieldsValue(res1?.data);

            setEditData(res1?.data);
            onValuesChange(true);
          }
        })
        .catch(() => {
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [allJSON]);

  useEffect(() => {
    Promise.all([capitalGoodsJSON()])
      .catch(() => {})
      .finally(() => {
        setAllJSON(true);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <AverageForm
        setSubmitDisabled={() => {}}
        suppliers={suppliers}
        isAverage={false}
        data={editData}
        setFormFacility={() => {}}
        setFormSelectedYear={() => {}}
        defaultDisplayStep={true}
      />
    </Form>
  );
};

export default CapitalGoodSupplierBills;
